export const NECESSARIO_INFORMAR_INDICACOES = 'É necessário informar indicações'
export const NECESSARIO_INFORMAR_PRODUTOS = 'É necessário informar produtos'
